module.exports = __webpack_public_path__ + "static/media/IMG_2606.67307c66.JPG";